module.exports = __webpack_public_path__ + "img/parking-sq.e7abefac.svg";